import { lazyLoad } from 'utils/loadable';

export const OpportunitiesPageLoadable = lazyLoad(
  () => import('./index'),
  module => module.OpportunitiesPage,
);

// Backward-compatible alias (if referenced elsewhere)
export const OpportunitiesPage = OpportunitiesPageLoadable;
